import React, { useEffect, useState } from "react";
import { splitDate } from "../../../utils/splitDate";
import { CalendarIconSvg } from "../../../assets/svg";
import { getSpecialAddon } from "../../../api/itinerary.api";
import { SpecialAddonItem } from "../../../pages/AddLeads/stepThree/Components/SpecialAddon";
import dayjs from "dayjs";
import CabinCard from "./CabinCard/CabinCard";
import SsrSection from "./SsrSection/SsrSection";
import CustomButton from "../../CustomButton/CustomButton";
import ItineraryTable from "./ItineraryTable/ItineraryTable";
import "./style.scss";

interface IItineraryDetailsModal {
  itineraryDetails: any;
}

const ItineraryDetailsModal: React.FC<IItineraryDetailsModal> = ({itineraryDetails}) => {
  const [selectedTab, setSelectedTab] = useState<1 | 2 | 3>(1);
  const [ssrData, setSsrData] = useState<SpecialAddonItem[]>([]);

  useEffect(() => {
    if(!ssrData?.length) fetchSsrData();
  }, []);
  
  const fetchSsrData = async () => {
    const data: any = await getSpecialAddon();
    if (data && data.status == 200) {
      setSsrData(data?.result);
    }
  };

  return (
    <div className="trip-info-modal-wrapper">
      <section className="trip-info-side-section">
        <CustomButton fillColor={selectedTab === 1} onButtonClick={() => setSelectedTab(1)}>
          Itinerary
        </CustomButton>
        <CustomButton fillColor={selectedTab === 2} onButtonClick={() => setSelectedTab(2)}>
          Cabins
        </CustomButton>
        {/* {!!ssrData?.length && <CustomButton fillColor={selectedTab === 3} onButtonClick={() => setSelectedTab(3)}>Special Services</CustomButton>} */}
      </section>
      <section className="trip-info-main-section">
        <div className="header-wrapper">
          <p className="text-uppercase">{itineraryDetails?.details?.route}</p>
          <div>
            <CalendarIconSvg/>
            <span>
            {dayjs(splitDate(itineraryDetails?.details?.start_time)).format("DD MMM YYYY")} - {dayjs(splitDate(itineraryDetails?.details?.end_time)).format("DD MMM YYYY")}
            </span>
          </div>
        </div>
        <div className="body-wrapper">
          {selectedTab === 1 && (
            <div className="flex flex-col gap-5">
              <div>
                <span className="itinerary-heading-1">Timeline</span>
                <span className="itinerary-heading-2">Event & Activities</span>
              </div>
              <ItineraryTable portDetails={itineraryDetails?.port_seq}/>
            </div>
          )}
          {selectedTab === 2 && (
            <div className="flex flex-col gap-3">
              <span className="cabin-heading">Available Cabin Details</span>
              <CabinCard cabinDetails={itineraryDetails?.rooms}/>
            </div>
          )}
          {selectedTab === 3 && <SsrSection ssrData={ssrData} />}
        </div>
      </section>
    </div>
  );
};

export default ItineraryDetailsModal;
